export const Dictionery = {
    mainName: {
        "fa": "لوکسین تریپ",
        "en": "Luxintrip"
    },
    call: {
        "fa": "شماره تماس",
        "en": "Phone number"
    },
    email: {
        "fa": "ایمیل",
        "en": "Email"
    },
    address: {
        "fa": "آدرس",
        "en": "Address"
    },
    communication: {
        "fa": "راه‌های ارتباطی:",
        "en": "Ways of communication:"
    },
    organizer: {
        "fa": "برگزارکننده",
        "en": "organizer"
    },
    more: {
        "fa": "مشاهده بیشتر",
        "en": "Show more"
    },
    moreAgency: {
        "fa": "مشاهده",
        "en": "Show"
    },
    notFoundText: {
        "fa": "صفحه مورد نظر یافت نشد",
        "en": "The page you are looking for is missing"
    },
    notFoundLink: {
        "fa": "رفتن به خانه",
        "en": "Going home"
    },
    loginSignup: {
        "fa": "ورود / ثبت نام",
        "en": "Login / Signup",
    },
    loginSignupDesc: {
        "fa": "به پنل آژانس لوکسین تریپ خوش آمدید! ما اینجا هستیم که کار هارا برای شما ساده تر کنیم.",
        "en": "Welcome to Luxin Trip agency panel! We are here to make things easier for you."
    },
    emailSentWithLink: {
        "fa": "ایمیل حاوی لینک برای شما ارسال شده، برای ادامه از لینک داخل ایمیل استفاده کنید.",
        "en": "An email containing a link has been sent to you, use the link in the email to continue."
    },
    passwordReseted: {
        "fa": "رمز عبور شما تغییر کرد. برای استفاده لاگین کنید.",
        "en": "Your password has been changed. Login to continue."
    },
    signupVerify: {
        "fa": "ثبت نام شما کامل شد. برای استفاده لاگین کنید.",
        "en": "Your registration is complete. Login to continue."
    },
    loginSignupInput1: {
        "fa": "ایمیل",
        "en": "Email"
    },
    loginSignupInput2: {
        "fa": "رمز عبور",
        "en": "Password"
    },
    loginSignupInput2Verify: {
        "fa": "تکرار رمز عبور",
        "en": "Repeat the password"
    },
    loginSignupInputNewPass: {
        "fa": "رمز عبور جدید",
        "en": "New password"
    },
    loginSignupInputNewPassVerify: {
        "fa": "تکرار رمز عبور جدید",
        "en": "Repeat the new password"
    },
    loginSignupBtn: {
        "fa": "ورود",
        "en": "Login"
    },
    signupBtn: {
        "fa": "ثبت نام",
        "en": "Sign up"
    },
    loginGuide: {
        "fa": "راهنمای ورود و ثبت نام",
        "en": "Login and registration guide"
    },
    forgetPassword: {
        "fa": "فراموشی رمز عبور",
        "en": "Forget password"
    },
    sendVerifyEmail: {
        "fa": "ارسال ایمیل",
        "en": "Send email"
    },
    savePassword: {
        "fa": "دخیره رمز عبور",
        "en": "Save password"
    },
    sendVerifyPassword: {
        "fa": "تغییر رمز عبور",
        "en": "Change Password"
    },
    BrokerPanel: {
        "fa": "پنل کارگزار",
        "en": "‌Broker Panel"
    },
    AgencyPanel: {
        "fa": "پنل آژانس",
        "en": "Agency Panel"
    },
    AdminPanel: {
        "fa": "پنل ادمین",
        "en": "Admin Panel"
    },
    mainWebsite: {
        "fa": "وبسایت",
        "en": "Website"
    },
    nowTours: {
        "fa": "تعداد تور های جاری",
        "en": "Number of current tours"
    },
    Tour: {
        "fa": "تور",
        "en": "Tour"
    },
    Name: {
        "fa": "نام و نام خانوادگی",
        "en": "first name and last name"
    },
    NationalCode: {
        "fa": "کد ملی",
        "en": "National Code"
    },
    TellNo: {
        "fa": "شماره تماس",
        "en": "Tell number"
    },
    Address: {
        "fa": "آدرس",
        "en": "Address"
    },
    PostalCode: {
        "fa": "کد پستی",
        "en": "Tell number"
    },
    PassportNo: {
        "fa": "شماره پاسپورت",
        "en": "Passport No"
    },

    PassportNoExp: {
        "fa": "تاریخ انقضا پاسپورت",
        "en": "Expiry date of passport"
    },
    avatar: {
        "fa": "آواتار",
        "en": "Avatar"
    },
    avatarDesc: {
        "fa": "برای تغییر یا آپلود کلیک کنید",
        "en": "Click to change or upload"
    },
    birthdate: {
        "fa": "تاریخ تولد",
        "en": "Birthdate"
    },
    gender: {
        "fa": "جنسیت",
        "en": "Gender"
    },
    genderMale: {
        "fa": "آقا",
        "en": "Male"
    },
    genderFemale: {
        "fa": "خانم",
        "en": "Female"
    },
    DistCountry: {
        "fa": "کشور مقصد",
        "en": "destination country"
    },
    DistCity: {
        "fa": "شهر مقصد",
        "en": "destination city"
    },
}